<template>
  <div class="header-space" v-if="isUPPLoyaltySubscribe == 'N'">
    <!-- NEW PROFILE SECTION START -->
    <section class="container-fluid bg-white min-vh-100 py-2 header-space">
      <!-- MY ACCOUNT START -->

      <div class="main-heading">
        <div>
          <hr class="primary-line" />
        </div>
        <div class="title"> {{ allLanguageData.Loyalty.singUpToEnjoy }}</div>
      </div>
      <section class="">
        <div class="emp_new_modal">
          <b-form>
            <div
              class="
                col-12 col-md-12 col-lg-9
                px-md-5
                newEmpGreyBG
                py-5
                mx-auto
                mb-4
              "
            >
              <div class="row">
                <div class="col-12 col-md-12 col-lg-12">
                  <div class="row">
                    <div class="col-12 col-md-6 mb-4">
                      <small
                        class="d-block fw-500"
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                      >
                        {{ allLanguageData.FName }}
                      </small>
                      <b-form-input
                        :disabled="true"
                        type="text"
                        id="fName"
                        v-validate="'required'"
                        name="First-Name"
                        v-model="profileDetails.FirstName"
                        class="text-capitalize"
                        :placeholder="allLanguageData.FName"
                        style="color:grey !important"
                      ></b-form-input>
                      <div
                        v-show="errors.has('updateProfile.First-Name')"
                        class="errorMessage"
                      >
                        {{ errors.first("updateProfile.First-Name") }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 mb-4">
                      <small
                        class="d-block fw-500"
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                      >
                        {{ allLanguageData.LName }}
                      </small>
                      <b-form-input
                        :disabled="true"
                        type="text"
                        id="sName"
                        name="Last-Name"
                        v-validate="'required'"
                        v-model="profileDetails.LastName"
                        class="text-capitalize"
                        :placeholder="allLanguageData.LName"
                        style="color:grey !important"
                      ></b-form-input>
                      <div
                        v-show="errors.has('updateProfile.Last-Name')"
                        class="errorMessage"
                      >
                        {{ errors.first("updateProfile.Last-Name") }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 mb-4">
                      <small
                        class="d-block fw-500"
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                      >
                        {{ allLanguageData.EmailId }}
                      </small>
                      <b-form-input
                        :disabled="true"
                        type="email"
                        v-validate="'required|email'"
                        id="userEmail"
                        name="email"
                        v-model="profileDetails.Email"
                        :placeholder="allLanguageData.Email"
                        style="color:grey !important"
                      ></b-form-input>
                    </div>
                    <div class="col-12 col-md-6 mb-4 profile-mobile">
                      <small
                        class="d-block fw-500"
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                      >
                        {{ allLanguageData.MobileNumber }}
                      </small>
                      <!-- {{ profileDetails.Mobile }} -->
                      <!-- v-model="profileDetails.Mobile" -->
                      <!-- :disabled="profileDetails.isLoyaltyMember || true" -->
                      <!-- :disabled="isLoyaltyMemebrValue" -->
                      <div class="d-flex align-items-center">
                        <!-- disabled = mobileVerified -->
                        <!-- contryList.find(
                              (o) => o.phonecode == profileDetails.CountryCode
                            ) &&
                              contryList.find(
                                (o) => o.phonecode == profileDetails.CountryCode
                              ).isoCode -->
                        <vue-phone-number-input
                          :disabled="true"
                          color="red"
                          :default-country-code="
                            contryList.find(
                              (o) => o.phonecode == profileDetails.CountryCode
                            ) &&
                              contryList.find(
                                (o) => o.phonecode == profileDetails.CountryCode
                              ).isoCode
                          "
                          @update="resultsExample = $event"
                          v-model="profileDetails.Mobile"
                        />
                        <div class="cursor-pointer">
                          <img
                            src="@/assets/img/svg/edit-black-icon.svg"
                            alt=""
                            width="15px"
                          />
                        </div>
                      </div>

                      <!-- <vue-tel-input
                        @input="onInput"
                        :value="profileDetails.Mobile"
                        :valid-characters-only="true"
                        :placeholder="allLanguageData.MobileNumber"
                        name="phonenumber"
                        :inputOptions="{
                          maxlength: 10,
                          disabled: mobileVerified ? false : true,
                        }"
                        :autoDefaultCountry="false"
                        :autoFormat="false"
                        :defaultCountry="selectedCountry"
                        class="form-control emp_tel d-flex"
                        @validate="onChangeMobileNum(profileDetails.Mobile)"
                      ></vue-tel-input> -->
                      <!-- :defaultCountry="profileDetails.CountryCode" -->
                      <div
                        v-show="errors.has('updateProfile.email')"
                        class="errorMessage"
                      >
                        {{ errors.first("updateProfile.email") }}
                      </div>
                      <router-link
                        @click.native="linkMobile"
                        style="color: red; cursor: pointer;font-size:12px;"
                        v-if="!mobileVerified"
                        to
                      >
                        <!-- Verify Mobile Number -->
                        {{ allLanguageData.MOBILENUMBERNOTVERIFIED }}
                      </router-link>
                      <p
                        v-else
                        style="color: green; cursor: pointer;font-size:12px;"
                      >
                        {{ allLanguageData.MOBILEVERIFIED }}
                      </p>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                      <small
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                        class="d-block fw-500"
                      >
                        <span class="important_mark">*</span>
                        {{ allLanguageData.Gender }}
                      </small>
                      <div class="d-flex align-items-center">
                        <div>
                          <b-form-radio
                            v-model="profileDetails.Gender"
                            v-on:change="onGenderChange('Male')"
                            value="Male"
                            name="some-radios "
                            class="small fw-500 lh-input"
                          >
                            {{ allLanguageData.Male }}
                          </b-form-radio>
                        </div>
                        <div>
                          <b-form-radio
                            v-model="profileDetails.Gender"
                            v-on:change="onGenderChange('Female')"
                            value="Female"
                            name="some-radios"
                            class="small fw-500 lh-input"
                          >
                            {{ allLanguageData.Female }}
                          </b-form-radio>
                        </div>
                      </div>

                      <p
                        v-if="
                          profileDetails.Gender == null ||
                            profileDetails.Gender == ''
                        "
                        style="color: red; cursor: pointer;font-size:12px;"
                        class="mt-2"
                      >
                        {{ genderError }}
                      </p>
                    </div>
                    <!-- <div class="col-12 col-md-6 mb-4">
                      <small class="d-block fw-500">
                        {{ allLanguageData.Nationality }}
                      </small>
                      <b-form-input
                        name="Member Since"
                        type="text"
                        v-model="profileDetails.Nationality"
                      ></b-form-input>
                    </div> -->
                    <div class="col-12 col-md-6 mb-4">
                      <!-- {{ profileDetails }} -->
                      <!-- {{ profileDetails.Birthdate }} -->

                      <small
                        class="d-block fw-500"
                        :style="langName == 'ar' ? 'text-align:right;' : ''"
                      >
                        <span class="important_mark">*</span>
                        {{ allLanguageData.DOB }}
                      </small>
                      <b-form-input
                        name="Birth Date"
                        v-validate="'required'"
                        type="date"
                        v-model="profileDetails.Birthdate"
                        :max="moment().format('YYYY-MM-DD')"
                        placeholder="dd/mm/yyyy"
                      ></b-form-input>
                      <p
                        v-if="
                          profileDetails.Birthdate == null ||
                            profileDetails.Birthdate == '' ||
                            profileDetails.Birthdate ==
                              new Date()
                                .toJSON()
                                .slice(0, 10)
                                .replace(/-/g, '-') ||
                            profileDetails.Birthdate >
                              new Date()
                                .toJSON()
                                .slice(0, 10)
                                .replace(/-/g, '-')
                        "
                        style="color: red; cursor: pointer;font-size:12px;"
                        class="mt-2"
                      >
                        {{ birthDateError }}
                      </p>
                      <!-- <b-form-datepicker
                        id="example-datepicker"
                        v-model="profileDetails.Birthdate"
                        class="mb-2"
                      ></b-form-datepicker> -->
                    </div>

                    <!--Preferred Lang Id Dropdown-->
                    <div class="col-12 px-md-2 px-xl-0 col-md-12 my-4">
                      <label class="address-label font-weight-bold">
                        {{ allLanguageData.Loyalty.Preferred_language }}
                      </label>

                      <div>
                        <multiselect
                          v-model="selectedPrferedLang"
                          :options="preferredlanguages"
                          label="lang_name"
                          track-by="lang_id"
                          class="custom-multiselect address-grid-dropdown"
                          :select-label="''"
                          :deselect-label="''"
                          :placeholder="
                            allLanguageData.Loyalty.select_Preferred_language
                          "
                          :selectedLabel="''"
                        >
                        </multiselect>
                        <!-- <span>{{ selectedPrferedLang.lang_id }}</span> -->
                      </div>
                    </div>
                    <!--Preferred Lang Id Dropdown Ends-->
                    <div v-if="false" class="col-12 px-0 col-md-12 my-4">
                      <label class="address-label font-weight-bold">
                        {{ allLanguageData.ADDRESSDETAILS }}
                      </label>
                      <div class="country-city-grid">
                        <div>
                          <multiselect
                            v-model="profileDetails.countryid"
                            :options="contryOptions"
                            label="text"
                            track-by="value"
                            class="custom-multiselect address-grid-dropdown"
                            :select-label="''"
                            :deselect-label="''"
                            :placeholder="allLanguageData.SELECTCOUNTRY"
                            :selectedLabel="''"
                          >
                          </multiselect>
                        </div>

                        <div>
                          <multiselect
                            v-model="profileDetails.City"
                            :options="cityOptions"
                            label="text"
                            track-by="value"
                            class="custom-multiselect address-grid-dropdown"
                            :select-label="''"
                            :deselect-label="''"
                            placeholder="Select City"
                            :selectedLabel="''"
                          >
                            <!-- allLanguageData.SELECTSTATE -->
                          </multiselect>
                          <p
                            v-if="
                              profileDetails.City == null ||
                                profileDetails.City == ''
                            "
                            style="color: red; cursor: pointer;font-size:12px;"
                            class="mt-2"
                          >
                            {{ StateError }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center my-4">
              <div
                class="btn emp-grey-btn"
                @click.prevent="UpdateProfileDetails(0)"
              >
                <!-- :style="mobileVerified ? '' : 'pointer-events: none;'" -->
                {{ allLanguageData.CommonModalInputs.SignUp }}
              </div>
            </div>
            <h6
              class="text-success small font-weight-bold text-center my-3"
              v-if="isPasswordCorrect && !errorMessage"
            >
              {{ FinalMessage }}
            </h6>
            <h6
              class="text-danger small font-weight-bold text-center my-3"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </h6>
          </b-form>
        </div>
      </section>
      <!-- MY ACCOUNT END -->
    </section>

    <b-modal
      no-close-on-backdrop
      id="updatedFailPopup"
      ref="updatedFailPopup"
      title="Update Fail"
      class="ErModal light-red-color"
    >
      <h6 class="py-5 mb-0 text-center font-weight-bold text-white">
        {{ "Profile Update Failed" }}
      </h6>
    </b-modal>
  </div>
</template>
<script>
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import { TokenService, UserService } from "@/services/storage.service";
import { EventBus } from "@/main";
import RangeSlider from "vue-range-slider";
import { URL_BASE } from "@/helper/constant";
import OtpInput from "@/components/OTP/OtpInput.vue";
import contryCodes from "@/helper/contryCodes.js";
import axios from "axios";

// you probably need to import built-in style
import "vue-range-slider/dist/vue-range-slider.css";
import { countries } from "../../helper/collection";
import moment from "moment";

export default {
  components: {
    RangeSlider,
    OtpInput,
  },
  data() {
    return {
      selectedPrferedLang: {
        lang_id: 1,
        lang_name: "English",
      },
      UserRecords: {},
      isUPPLoyaltySubscribe: "",
      preferredlanguages: [{}],
      contryList: contryCodes,
      resultsExample: null,
      mobileVerified: true,
      contryOptions: [
        // { value: null, text: 'Please select Country', disabled: true },
      ],
      cityOptions: [
        // { value: null, text: 'Please select City', disabled: true },
      ],
      selectedCountry: "966",
      selectedCountryCode: "966",

      SelectedCity: "Select City",
      citySelect: null,
      countrySelect: null,
      bindProps: {
        mode: "auto",

        // defaultCountry: "SA",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: true,
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["SA", "LB", "IQ"],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 9,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
      URL_BASEImg: URL_BASE + "/",
      isMobileChange: false,
      errorMessage: "",
      FinalMessage: "",
      uplodedUserPic: "",
      OldPasswordType: "",
      NewPasswordType: "",
      imageee: "",
      aaa: true,
      isCheckPassword: 0,
      selected: "",
      isPasswordIncorrect: true,
      isPasswordCorrect: false,
      sliderValue: 50,
      clubEmpire: false,
      booking: true,
      account: false,
      preferencess: false,
      tabLocate: 0,
      tabMember: 0,
      loyalityPopUpMessage: "",
      title: "My Profile Page",
      preimere: false,
      userOtp: null,
      isEdit: true,
      msg: "",
      errorMsg: "",
      UserNewNumber: "",
      LoyaltyMemberinfo: [],
      LoyaltyMemberHistoryLog: [],
      TicketBookingDetails: [],
      loyaltyData: [],
      profileDetails: {
        FirstName: null,
        LastName: null,
        Email: null,
      },
      city_id: null,
      genreList: [],
      cinemaList: [],
      languageList: [],
      bookingDetails: [],
      expeirdBookings: [],
      upComingBookings: [],
      preferenceCinemaList: [],
      preferenceExperiencesList: [],
      preferenceFoodList: [],
      AddPreferenceMessage: "",
      upComingBookingData: [],
      expeirdBookingData: [],
      birthDate: "",
      birthDateError: "",
      genderError: "",
      CountryError: "",
      StateError: "",
      OldMobileNumber: "",
      // birthDate: {
      //   date1: "01",
      //   month: "Jan",
      //   year: "2019",
      // },
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      years: [],
      age: "",
      message: "",
      selectedCountry: "SA",
    };
  },

  watch: {
    "profileDetails.countryid": {
      handler(newCountry, oldCountry) {
        console.log(this.profileDetails.countryid, "bfgfd");
        this.profileDetails.countryid = newCountry;
        // this.profileDetails.City = this.profileDetails.City
        //   ? this.profileDetails.City
        //   : null;
        this.fetchCities(newCountry.value);
        // this.cityOptions.push({
        //   value: null,
        //   text: "Please select City",
        //   disabled: true,
        // });
      },
    },
    resultsExample: {
      handler(value) {
        console.log(value);
        this.isValidNumber = value.isValid;
        this.selectedCountryCode = value.countryCallingCode;
        console.log(this.selectedCountryCode, "hdhdhsksksh");
      },
    },
  },
  mounted: function() {
    this.preferredLang();
  },
  computed: {
    getSelectedBrijCinemas() {
      return this.$store.getters.getSelectedBrijCinemas;
    },
    getPreferencesOptions() {
      return this.$store.getters.getPreferencesOptions;
    },
    getBrijCinemas() {
      return this.$store.getters.getBrijCinemas;
    },
    getUserHistory() {
      return this.$store.getters.getUserHistory;
    },
    getUserHistoryRefunded() {
      return this.$store.getters.getUserHistoryRefunded;
    },
    getUserHistoryExpired() {
      return this.$store.getters.getUserHistoryExpired;
    },
    // selectedCountry() {
    //   // let ISOcode = .toString();
    //   this.$forceUpdate();
    //   return this.profileDetails && this.profileDetails.CountryISOCode
    //     ? this.profileDetails.CountryISOCode.toString()
    //     : "";
    // },
    isLoyaltyMemebrValue() {
      return !(
        this.profileDetails.isLoyaltyMember == "1" ||
        this.profileDetails.isLoyaltyMember == 1
      );
    },
    CurrentCard() {
      if (this.LoyaltyMemberinfo.TierType === "RED") {
        return "red-card";
      } else if (this.LoyaltyMemberinfo.TierType === "BRONZE") {
        return "bronze-card";
      } else if (this.LoyaltyMemberinfo.TierType === "SILVER") {
        return "silver-card";
      } else if (this.LoyaltyMemberinfo.TierType === "GOLD") {
        return "gold-card";
      }
    },
    mProgressBar() {
      let percentage = 33.33;
      if (
        this.LoyaltyMemberinfo.TotalEarnedPoints <=
        this.LoyaltyMemberinfo.RedPoints
      ) {
        let value = this.LoyaltyMemberinfo.RedPoints / percentage;
        return this.LoyaltyMemberinfo.TotalEarnedPoints / value;
      } else if (
        this.LoyaltyMemberinfo.TotalEarnedPoints <=
        this.LoyaltyMemberinfo.BronzPoints
      ) {
        let value =
          (this.LoyaltyMemberinfo.BronzPoints -
            this.LoyaltyMemberinfo.RedPoints) /
          percentage;
        return (
          (this.LoyaltyMemberinfo.TotalEarnedPoints -
            this.LoyaltyMemberinfo.RedPoints) /
            value +
          percentage
        );
      } else if (
        this.LoyaltyMemberinfo.TotalEarnedPoints <=
        this.LoyaltyMemberinfo.SliverPoints
      ) {
        let value =
          (this.LoyaltyMemberinfo.SliverPoints -
            this.LoyaltyMemberinfo.BronzPoints) /
          percentage;
        return (
          (this.LoyaltyMemberinfo.TotalEarnedPoints -
            this.LoyaltyMemberinfo.BronzPoints) /
            value +
          percentage * 2
        );
      } else {
        return 100;
      }
    },
    LoyaltyCustomerVerfiy() {
      return localStorage.getItem("LoyaltyCustomerVerfiy");
    },
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  beforeCreate: function() {
    let pre = window.localStorage.getItem("PREIMERE");
    if (pre == null || pre == "false" || pre == false) {
      // document.body.className = "img-section";
    } else {
      // document.body.className = "gold-img-section";
    }
  },

  updated: function() {
    // console.log('parameter check', this.profileDetails.countryid, this.contryOptions)
    // this.profileDetails.countryid = this.contryOptions.find(option => option.value === this.profileDetails.countryid);
    // console.log('mouted contry',this.profileDetails.countryid)
    // EventBus.$on("pTabChange", payload => {
    // });
    // setTimeout(() => {
    //   if (this.profileDetails.Nationality && this.profileDetails.Gender) {
    //     //do something
    //   } else {
    //     this.$refs.updateProfileReminder.show();
    //   }
    // }, 1000);

    let getTab = localStorage.getItem("changeTabProfile");
    if (getTab > 0) {
      this.tabLocate = 3;
    }
    if (this.langName == "ar") {
      this.title = "ملفي الشخصي الصفحة";
    }
    this.preimere = window.localStorage.getItem("PREIMERE");
    // sessionTimeOut
  },

  beforeDestroy() {
    localStorage.removeItem("profileTabType");
    localStorage.setItem("changeTabProfile", 0);
  },

  beforeMount() {
    let tabType = localStorage.getItem("profileTabType");
    this.ChangeProfileTabs(tabType, 0);
    this.fetchProfileDetails();

    // this.$store.dispatch("fetchBrijPrefOptions");
    this.langPref();

    // this.fetchGenreList()
    // this.fetchLanguageList();
    // console.log(this.fetchLanguageList(), "this.fetchLanguageList()");
    // this.fetchBookingHistoryDetails()
    // this.fetchCinemaList()
    // this.fetchPreferenceCinemaList()
    // this.fetchPreferenceExperiencesList()
    // this.fetchPreferenceFoodList()

    for (var i = new Date().getFullYear(); i > 1900; i--) {
      this.years.push(i);
    }

    let user = UserService.getUserProfile();
    console.log({ user });
    if (user && user.UserID) {
      this.$store.dispatch("fetchUserHistory", user.UserID);
    }
  },
  methods: {
    moment,
    langPref: async function() {
      await this.$store.dispatch("fetchBrijPrefOptions");
      this.hideLoading();
      this.preferredLang();
    },
    preferredLang() {
      this.preferredlanguages = this.getPreferencesOptions.language_list.map(
        (x) => ({
          lang_name: x.lang_name,
          lang_id: x.lang_id,
        })
      );
      console.log(this.preferredlanguages, "lang_ids");
    },

    linkMobile() {
      this.showLoading();
      const payload = {
        change_number: this.profileDetails.Mobile.trim()
          .split(" ")
          .join(""),
        resend_otp: "",
        verification_id: localStorage.getItem("verification_id"),
      };
      makeRequestBrij("/api/cinema/verify-user", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          console.log(res.data, "Records");
          if (res.data.status) {
            this.$router.push({
              path: "/phoneOtp",
            });
          } else {
            console.log("Error", res.data);
            this.$refs.updatedFailPopup.show();
            alert("Number already registered.");
          }
          this.hideLoading();
        })
        .catch((error) => {});
    },
    onChangeMobileNum: function({ number, isValid, country }) {
      this.isMobileChange = true;
    },
    onDropdownCountry(country) {
      this.SelectedCountry = country.text;
      this.profileDetails.CountryID = country.value;
    },
    onDropdownCity(city) {
      console.log(city);
      this.SelectedCity = city.text;
    },
    fetchContries() {
      makeRequestBrij("/api/external/countries/", "GET", null, null)
        .then((result) => {
          const { error, res } = result;
          // const { data } = res.data
          // console.log(res.data, 'res.data')
          // console.log(
          //   this.contryOptions,
          //   "countryoptions",
          //   this.profileDetails.countryid
          // );
          this.contryOptions = res.data.data.map((z) => {
            return { value: z.country_id, text: z.country_name };
          });

          // console.log('parameter check', this.profileDetails.countryid, this.contryOptions)
          this.profileDetails.countryid = this.contryOptions.find(
            (option) => option.value === this.profileDetails.countryid
          );
          // console.log('mouted contry', this.profileDetails.countryid)
          // this.contryOptions.push({
          //   value: null,
          //   text: 'Please select Country',
          //   disabled: true,
          // })
        })
        .catch((err) => console.log(err));
    },
    fetchCities(countryId) {
      var config = {
        method: "get",
        url: `${
          this.BrijBaseUrl
        }/api/get_ms_states_list?state_is_active=Y&country_id=${countryId}`,
      };
      this.cityOptions = [];

      axios(config).then((result) => {
        const { error, data } = result;
        if (data.Records && data.Records.length) {
          console.log(this.cityOptions, "hdhdhdhd", this.profileDetails.City);
          this.cityOptions = data.Records.map((val) => {
            return {
              value: val.state_id || "",
              text: val.state_name || "",
              cmp: String(val.state_name)
                .trim()
                .toUpperCase(),
            };
          });
          this.cityOptions = this.cityOptions.sort((a, b) =>
            a.cmp.localeCompare(b.cmp)
          );

          this.profileDetails.City = this.cityOptions.find(
            (option) => option.value === this.profileDetails.City
          );

          // console.log(this.cityOptions, 'dasdasd')
        }
      });
    },

    redirectToMyaccount(type) {
      this.$refs.updateProfileReminder.hide();
      localStorage.setItem("profileTabType", type);
      this.$nextTick(() => {
        this.ChangeProfileTabs(type, 1);
      });
      localStorage.setItem("changeTabProfile", 3);
    },

    onChangeMobileNum: function(newNumber) {
      if (newNumber == this.OldMobileNumber) {
        this.isMobileChange = false;
      } else {
        this.isMobileChange = true;
      }
    },
    onOTPValue: ({ ...payload }) => {
      // this.NewOTP = payload.value;
    },
    resetVerifyUserErrors(event) {},
    openBookingDetails(value, type) {
      if (type == "upComing") {
        this.upComingBookingData = this.upComingBookings[value];
        // this.$refs.expeirdBookingDetails.hide();
        // this.$refs.upComingBookingDetails.show();
      } else if (type == "expeird") {
        this.expeirdBookingData = this.expeirdBookings[value];
        // this.$refs.upComingBookingDetails.hide();
        // this.$refs.expeirdBookingDetails.show();
      }
    },

    openBookedTicket(val, type) {
      this.TicketBookingDetails = [];

      this.$nextTick(() => {
        this.$refs.TicketDetailsModal.show();
        this.TicketBookingDetails = val;
        this.loyaltyData = val.loyaltydata;
      });
    },
    onInput(formattedNumber, { number, valid, country }) {
      this.UserNewNumber = formattedNumber;
      console.log(this.UserNewNumber);
      this.profileDetails.CountryCode = country.dialCode;
    },
    // onInputVerify(formattedNumber, { number, valid, country }) {
    //   // this.profileDetails.Mobile = formattedNumber;
    //   this.profileDetails.CountryCode = country.dialCode;
    // },

    filesChange(file, path) {
      console.log(
        "name, filename, filename, filename, file :>> ",
        file[0].name
      );
    },
    ChangeProfileTabs(value, type) {
      if (type == 1 || type == "1") {
        localStorage.setItem("profileTabType", value);
      }
      if (value === "clubEmpire") {
        this.clubEmpire = true;
        this.booking = false;
        this.account = false;
        this.preferencess = false;
      } else if (value === "booking") {
        this.clubEmpire = false;
        this.booking = true;
        this.account = false;
        this.preferencess = false;
      } else if (value === "account") {
        this.clubEmpire = false;
        this.booking = false;
        this.account = true;
        this.preferencess = false;
      } else if (value === "preferencess") {
        this.clubEmpire = false;
        this.booking = false;
        this.account = false;
        this.preferencess = true;
      }
    },
    changeTabMember() {
      this.tabMember = 2;
    },
    verifiedAccount() {
      localStorage.setItem("LoyaltyCustomerVerfiy", 1);
      window.location.reload(true);
    },
    successClosed() {
      // this.$refs.successPopup.hide();
      this.$refs.loyalityPopup.hide();
    },
    editUserNumber: function() {
      this.isEdit = false;
    },
    verifyUserForLp: function(value) {
      // if (data == "ResendOtp") {
      //   this.$refs.resendOtpPoup.show();
      // }

      let token = TokenService.getToken();
      let payload = {
        Email: this.profileDetails.Email,
        Mobile: this.UserNewNumber
          ? this.UserNewNumber.trim()
              .split(" ")
              .join("")
          : this.profileDetails.Mobile,
        // CountryCode: this.profileDetails.Default.CountryCode,
        CountryCode: this.profileDetails.CountryCode,
        CinemaType: "normal",
        LanguageID: this.profileDetails.LanguageID,
        CountryID: this.profileDetails.Default.CountryID,
        // CountryID: this.profileDetails.CountryID,
        Action: value,
        FirstName: this.profileDetails.FirstName,
        LastName: this.profileDetails.LastName,
        Birthdate: this.profileDetails.Birthdate,
        Gender: this.profileDetails.Gender,
        UserID: this.profileDetails.UserID,
        TheatreId: 3,
        OTP: "",
      };

      // console.log("payload :>> 1111111111", payload);
      // 2
      makeRequest("/LoyaltyCustomer/", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.Status) {
            this.$refs.verifyAccount.show();
            if (value == "ResendOtp") {
              this.errorMsg = res.data.vallidateuserdata[0].ErrMessage;
            }
          } else {
            this.loyalityPopUpMessage = res.data.Message;
            this.$refs.loyalityPopup.show();
          }
        })
        .catch((error) => {
          this.message = "Something went wrong";
        });
    },
    // 1
    finalVerifyUserForLp: function() {
      this.errorMsg = "";
      let token = TokenService.getToken();
      let payload = {
        Email: this.profileDetails.Email,
        Mobile: (this.UserNewNumber || "")
          .trim()
          .split(" ")
          .join(""),
        CountryCode: this.profileDetails.Default.CountryCode,
        CinemaType: "normal",
        LanguageID: this.profileDetails.LanguageID,
        CountryID: this.profileDetails.Default.CountryID,
        Action: "NewUser",
        FirstName: this.profileDetails.FirstName,
        LastName: this.profileDetails.LastName,
        Birthdate: this.profileDetails.Birthdate,
        // Birthdate:
        //   this.birthDate.date1 +
        //   "-" +
        //   this.birthDate.month +
        //   "-" +
        //   this.birthDate.year,

        Gender: this.profileDetails.Gender,
        UserID: this.profileDetails.UserID,
        TheatreId: 3,
        OTP: this.userOtp,
      };

      console.log("payload :>> ", payload);
      // 1
      makeRequest("/LoyaltyCustomer/", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.Status) {
            this.msg =
              res.data.Message == ""
                ? "Account Verified. You are join for loyality program."
                : res.data.Message;
            this.$refs.verifyAccount.hide();
            this.$refs.updatedPopup.show();
          } else {
            this.errorMsg = res.data.Message;
          }
        })
        .catch((error) => {
          this.errorMsg = "Something went wrong";
        });
    },
    LoyaltyMemberDetails: function() {
      let token = TokenService.getToken();
      let payload = {
        CinemaType: "normal",
        LanguageID: this.profileDetails.LanguageID,
        CountryID: this.profileDetails.Default.CountryID,
        TheatreId: 3,
      };
      console.log("payloadpayload :>> ", payload);
      makeRequest("/LoyaltyMemberDetails", "POST", token, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            console.log(" res.data res.data :>> ", res.data);
            this.LoyaltyMemberinfo = res.data;
            // this.LoyaltyMemberinfo.TotalEarnedPoints = 15000;
            this.LoyaltyMemberinfo.TierType = this.LoyaltyMemberinfo.TierType.toUpperCase();

            // this.redLevel = res.data.filter(x =>{
            //   return x.
            // })
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    LoyaltyMemberHistory: function() {
      let token = TokenService.getToken();
      this.LoyaltyMemberHistoryLog = [];
      let payload = {
        CinemaType: "normal",
        LanguageID: this.profileDetails.LanguageID,
        CountryID: this.profileDetails.Default.CountryID,
        TheatreId: 3,
        Type: "ALL",
      };
      console.log("LoyaltyMemberHistory :>> ", payload);
      makeRequest("/LoyaltyMemberHistory", "POST", token, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            console.log(" LoyaltyMemberHistory ", res.data);
            if (res.data.hasOwnProperty("PointsList")) {
              let obj = {
                title: "All",
                dataNew: res.data.PointsList,
              };

              this.LoyaltyMemberHistoryLog.push(obj);

              let type_ar = ["All"];
              res.data.PointsList.map((x) => {
                let checkIndex = type_ar.indexOf(x.points_type);
                if (checkIndex >= 0) {
                  this.LoyaltyMemberHistoryLog[checkIndex]["dataNew"].push(x);
                } else {
                  let obj1 = {
                    title: x.TrnTypedisplay,
                    dataNew: [x],
                  };
                  type_ar.push(x.points_type);
                  this.LoyaltyMemberHistoryLog.push(obj1);
                }
              });
              // console.log(object);
            }
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    onGenderChange: function(value) {
      this.profileDetails.Gender = value;
    },
    selectPreference: function(item, selectedPreference) {
      let payload = {
        ID: item.ID,
        PreferenceType: selectedPreference,
      };
      if (item.selected == false) {
        payload.Active = 1;
      } else {
        payload.Active = 0;
      }
      makeRequest("/AddPreferences", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            // Thank you pop up!
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    onSelectDate: function(value, type) {
      if (type == "date") {
        this.birthDate.date1 = value;
      } else if (type == "month") {
        this.birthDate.month = value;
      } else if (type == "year") {
        this.birthDate.year = value;
      }
      this.getAge(
        this.birthDate.year +
          "/" +
          this.birthDate.month +
          "/" +
          this.birthDate.date1
      );
    },
    getAge: function(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      this.age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      // console.log('m,age,birthDate :', m,age,birthDate);
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        this.age = this.age--;
      }
    },
    fetchProfileDetails: function() {
      this.showLoading();
      let token = TokenService.getToken();
      makeRequestBrij(
        `/api/external/get-customer-details/${token}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          res.data.EmpireData = res.data.EmpireData || {};
          const { data } = res.data;
          // this.profileDetails.FirstName = "";
          // this.profileDetails.LastName = "";
          // this.profileDetails.Email = "";
          // this.profileDetails.Mobile = "";
          // this.profileDetails.Gender = "";
          // this.profileDetails.Birthdate = "";
          if (!error) {
            const details = { ...res.data };
            console.log("details:::: :>> ", details);
            this.profileDetails = { ...res.data.EmpireData };
            this.city_id = this.profileDetails.City;
            // console.log(this.city_id, "this.city_id");
            this.UserRecords = res.data.Records || {};
            this.isUPPLoyaltySubscribe = this.UserRecords[0].upp_loyality_registered;

            // console.log(this.isUPPLoyaltySubscribe, "isUPPLoyaltySubscribe");
            this.profileDetails.Gender = "";
            this.profileDetails.Birthdate = "";
            this.profileDetails.countryid =
              res.data.EmpireData.countryid == 230
                ? 194
                : res.data.EmpireData.countryid;
            localStorage.setItem(
              "profile_detail",
              JSON.stringify(this.profileDetails)
            );
            localStorage.setItem(
              "verification_id",
              this.profileDetails.verification_id
            );
            this.fetchContries();

            this.OldMobileNumber = res.data.EmpireData.Mobile;
            // console.log('profile', this.profileDetails)
            // const a = this.contryList.find(
            //   (o) => o.phonecode == this.profileDetails.CountryCode,
            // ).isoCode
            // console.log(a, 'kkjhhh')

            this.profileDetails["personalnotification"] =
              res.data.EmpireData.personalnotification == "1";
            this.profileDetails["movienotification"] =
              res.data.EmpireData.movienotification == "1";

            if (res.data.EmpireData.verfiymobile) {
              this.mobileVerified = true;
            } else {
              this.mobileVerified = false;
            }

            let CountryISOText = res.data.EmpireData.CountryISOCode
              ? res.data.EmpireData.CountryISOCode.toUpperCase()
              : null;
            this.profileDetails.CountryISOCode = CountryISOText
              ? CountryISOText.toString()
              : null;
            this.selectedCountry = CountryISOText
              ? CountryISOText.toString()
              : "";
            this.hideLoading();

            // this.$nextTick(() => {
            //   this.$forceUpdate();
            // });

            this.UserNewNumber = res.data.EmpireData.Mobile;
            this.LoyaltyMemberDetails();
            this.LoyaltyMemberHistory();
            // if (this.profileDetails.Nationality && this.profileDetails.Gender) {
            //   // do something
            // } else {
            //   this.$refs.updateProfileReminder.show();
            // }
            // if (this.profileDetails.Birthdate.length > 0) {
            //   this.birthDate.date1 = this.profileDetails.Birthdate.split(
            //     "-"
            //   )[0];
            //   this.birthDate.month = this.profileDetails.Birthdate.split(
            //     "-"
            //   )[1];
            //   this.birthDate.year = this.profileDetails.Birthdate.split("-")[2];
            //   this.getAge(
            //     this.birthDate.year +
            //       "/" +
            //       this.birthDate.month +
            //       "/" +
            //       this.birthDate.date1
            //   );
            // }
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    fetchGenreList: function() {
      let token = TokenService.getToken();
      makeRequest("/GenrePrefList", "POST", token, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.genreList = res.data.GenreList;
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    fetchLanguageList: function() {
      makeRequest("/LanguagePrefList", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;

          if (!error) {
            this.languageList = res.data.LanguageList;
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    fetchCinemaList: function() {
      makeRequest("/CinemaPrefList", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.cinemaList = res.data.CinemaList;
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    fetchPreferenceCinemaList: function() {
      // this.showLoading();
      makeRequest("/CinemaPrefList", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.preferenceCinemaList = res.data.CinemaList;
            // this.hideLoading();
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    fetchPreferenceExperiencesList: function() {
      makeRequest("/ExperiencePrefList", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.preferenceExperiencesList = res.data.ExpList;
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    fetchPreferenceFoodList: function() {
      makeRequest("/FoodPrefList", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            this.preferenceFoodList = res.data.GenreList;
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    AddPreference: function(id, active, type, itemSelected) {
      let cust_id = itemSelected.cust_id;
      let user = UserService.getUserProfile();
      if (user && user.UserID && !cust_id) {
        cust_id = user.UserID;
      }

      let payload = {
        cust_id,
        active,
        pref_id: itemSelected.pref_id,
        pref_type:
          itemSelected.pref_type ||
          (type == "Cinema" ? 1 : type == "expeience" ? 2 : 3),
        selection_id:
          type == "Cinema"
            ? itemSelected.cine_id
            : type == "expeience"
            ? itemSelected.mf_id
            : itemSelected.item_id,
      };

      makeRequestBrij(`/api/cinema/user-prefs`, "POST", null, payload).then(
        (result) => {
          // console.log({result})
        }
      );
    },

    changePassword: function() {
      this.UpdateProfileDetails(1);
    },

    UpdateProfileDetails: function(value) {
      this.showLoading();
      this.isCheckPassword = value;
      console.log(
        "this.profileDetails.CountryCode ",
        this.profileDetails.CountryCode
      );

      // let payload = {
      //   FirstName: this.profileDetails.FirstName,
      //   LastName: this.profileDetails.LastName,
      //   Email: this.profileDetails.Email,
      //   CountryCode: this.selectedCountryCode || '966',
      //   // Mobile: this.profileDetails.Mobile,
      //   Mobile: this.UserNewNumber
      //     ? this.UserNewNumber.trim().split(' ').join('')
      //     : this.profileDetails.Mobile,
      //   Gender: this.profileDetails.Gender,
      //   Birthdate: this.profileDetails.Birthdate,
      //   checkpassword: this.isCheckPassword,
      //   Nationality: this.profileDetails.Nationality,
      //   personalnotification:
      //     this.profileDetails.personalnotification == true ? 1 : 0,
      //   movienotification:
      //     this.profileDetails.movienotification == true ? 1 : 0,
      //   Oldpassword: this.OldPasswordType,
      //   Newpassword: this.NewPasswordType,
      //   Profileimage: this.profileDetails.Profileimage,
      //   CountryID: this.profileDetails.CountryID,
      //   countryid: this.profileDetails.countryid.value,
      //   CityID: this.profileDetails.City.value,
      //   City: this.profileDetails.City.value,
      //   alert: 'on',
      // }

      console.log(this.profileDetails.Mobile, this.UserNewNumber);
      if (!this.resultsExample.isValid) {
        this.errorMessage = `Enter Valid Mobile Detail`;
        this.hideLoading();
        return;
      }
      let payloadNew = {
        email: this.profileDetails.Email,
        first_name: this.profileDetails.FirstName,
        last_name: this.profileDetails.LastName,
        phone_no: this.profileDetails.Mobile.trim()
          .split(" ")
          .join(""),
        country_id: this.profileDetails.countryid,
        dob: this.profileDetails.Birthdate,
        preferred_lang_id: this.selectedPrferedLang.lang_id
          ? this.selectedPrferedLang.lang_id
          : 1,
        state_id: this.city_id || 1,
        CountryCode: this.selectedCountryCode,
        personalnotification:
          this.profileDetails.personalnotification == true ? 1 : 0,
        movienotification:
          this.profileDetails.movienotification == true ? 1 : 0,
        gender: this.profileDetails.Gender,
        checkNumberChanged: this.UserNewNumber != this.profileDetails.Mobile,
      };

      if (!this.isValidNumber) {
        this.errorMessage = `Mobile Number is invalid.`;
        this.hideLoading();
        return;
      }

      if (
        this.profileDetails.Gender == null ||
        this.profileDetails.Gender == ""
      ) {
        this.genderError = `Please Select Gender Detail`;
        this.hideLoading();
        return;
      }

      if (
        this.profileDetails.Birthdate == null ||
        this.profileDetails.Birthdate == "" ||
        this.profileDetails.Birthdate ==
          `${String(
            new Date()
              .toJSON()
              .slice(0, 10)
              .replace(/-/g, "-")
          )}`
      ) {
        this.birthDateError = `Please Select Your Birth Date`;
        this.hideLoading();
        return;
      }

      // if (
      //   this.profileDetails.countryid.value == null ||
      //   this.profileDetails.countryid.value == ""
      // ) {
      //   this.CountryError = `Please Select Your Country`;
      //   this.hideLoading();
      //   return;
      // }
      // if (this.profileDetails.City == null || this.profileDetails.City == "") {
      //   this.StateError = `Please Select Your City`;
      //   this.hideLoading();
      //   return;
      // }

      let token = TokenService.getToken();
      makeRequestBrij(
        `/api/external/update-user/${token}`,
        "POST",
        null,
        payloadNew
      )
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          this.hideLoading();

          if (!error && res.data.status) {
            // this.profileDetails = res.data;
            // newData: {
            //   profileName: this.profileDetails.FirstName;
            //   profilePic: this.profileDetails.Profileimage;
            // }

            EventBus.$emit("updateProfile", this.profileDetails.FirstName);
            this.fetchProfileDetails();
            ChangeProfileTabs("clubEmpire", 1);

            if (value == 0 || value == "0") {
              this.FinalMessage = res.data.messafe;
              this.isPasswordCorrect = true;
            } else {
              this.message = res.data.message;
              this.FinalMessage = "";
            }
            // this.successMessage = res.data.Message;

            if (value == 1) {
              this.isPasswordIncorrect = false;
              this.isPasswordCorrect = false;
            }
            if (value == 0) {
              this.NewPasswordType = "";
              this.OldPasswordType = "";
              this.message = "";
            }
          } else {
            if (value == 1) {
              this.isPasswordIncorrect = true;
              this.isPasswordCorrect = true;
            }
            this.errorMessage = res.data.Message;
          }

          // setTimeout(() => {
          //   this.hideLoading();
          // }, 10000);
        })
        .catch((error) => {
          this.hideLoading();
          this.message = "Something went wrong";
          console.log("Error on vue front", error);
        })
        .then(() => {
          this.$router.push({
            path: "/profile",
          });
        });

      // 3
      // makeRequest("/LoyaltyCustomer/", "POST", null, payload).then(result => {
      //   console.log(result);
      // });
      makeRequest("/LoyaltyCustomer/", "POST", null, payloadNew)
        .then((result) => {
          console.log(result, "test123");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
body {
  border: none;
}
ul:focus {
  outline: none;
}
.footer {
  background-image: none !important;
}
.fs-12 {
  font-size: 12px;
}
.fs-13 {
  font-size: 13px;
}
.fs-14 {
  font-size: 14px;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-gold {
  background: #e6be8a;
  color: black;
}
.points-tabs {
  display: block !important;
}
.lh-5 {
  line-height: 05px;
}
.lh-22 {
  line-height: 20px;
}
.bg-success-circle {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 8px;
  background: #dbf5d9;
  border: 2px solid #dbf5d9;
  color: #666;
  text-align: center;
  line-height: 16px;
}
.bg-danger-circle {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 8px;
  background: #fae7ec;
  border: 2px solid #fae7ec;
  color: red;
  text-align: center;
  line-height: 16px;
}
.accordian-box a[aria-expanded="true"]:after {
  content: "↑";
  font-size: 22px;
  float: right;
  transition: all 0.5s;
}
.accordian-box a[aria-expanded="false"]:after {
  content: "↓";
  font-size: 22px;
  float: right;
  transition: all 0.5s;
}

.walletDetails-box {
  background-color: #434345;
  color: #fff;
  font-size: 13px;
  padding: 0.6rem 0rem;
  /* border-radius: 24px; */
  cursor: pointer;
}

/*

  .profile-tabs .nav-tabs {
    justify-content: center;
    border-top: 1px dotted #fff;
    border-bottom: 1px dotted #fff;
  }

  .preference-tabs .nav-tabs {
    border-bottom: none;
  }

  .profile-tabs .nav-link,
  .preference-tabs .nav-tabs .nav-link {
    color: #810c13;
    font-weight: bold;
    border: none !important;
  }

  .profile-tabs .nav-link:hover,
  .profile-tabs .nav-link.active,
  .preference-tabs .nav-tabs .nav-link:hover,
  .preference-tabs .nav-tabs .nav-link.active {
    color: #fff;
    position: relative;
    background-color: transparent;
  } */

/* .profile-tabs .nav-link.active::after {
    left: 50%;
    content: "";
    height: 15px;
    width: 15px;
    display: block;
    bottom: -13px;
    position: absolute;
    border-right: 1px dotted #fff;
    border-bottom: 1px dotted #fff;
    transform: rotate(45deg) translateX(-50%);
    background: url("../../assets/img/svg/red-bg.svg") no-repeat center center;
    background-size: cover;
  }

  .profile-tabs .nav-link:focus,
  .profile-tabs .nav-link:hover {
    white-space: nowrap;
    border: none !important;
  } */

@media (max-width: 767px) {
  body {
    font-size: 14px;
  }

  .preference-tabs .tabs {
    display: flex;
    flex-wrap: wrap;
  }

  .profile-container {
    padding: 30px 20px;
    margin-bottom: 175px;
  }

  .profile-container .dotted-border-x {
    border-left: 0;
    border-right: 0;
  }

  /* .profile-tabs .nav {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: flex-start;
  } */

  .profile-container .form-row {
    margin-bottom: 25px;
  }

  .profile-container .content {
    width: 95%;
    padding-top: 0;
  }

  /* .fixed-save {
      padding: 0;
      display: flex;
      min-height: 100px;
      align-items: center;
    } */
}

@media (max-width: 576px) {
  .profile-container {
    padding: 25px 0;
  }

  .preference-tabs .nav {
    overflow-x: auto;
    flex-wrap: nowrap;
    margin-left: 10px;
    overflow-y: hidden;
    margin-right: 10px;
    white-space: nowrap;
  }
}

@media (max-width: 576px) {
  .lang-list li,
  .genre-list li,
  .prefCinema-list li {
    min-width: 85px;
  }

  .lang-list li label,
  .genre-list li label,
  .prefCinema-list li label {
    font-size: 10px;
  }
}
.ticket-container .ticket-cutter-1,
.ticket-container .ticket-cutter-2 {
  background: #cf1f2e;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/loyaltyForm.vue